import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { GlobalStateHelper } from '@helpers/GlobalStateHelper';
import ConfigService from '@config/ConfigService';
import { RouteMapHelper } from '@helpers/RouteMapHelper';

@Injectable({
  providedIn: 'root'
})
export class LogoutScreenGuard  {
  private currentLang: string;

  constructor(
    private router: Router,
    private globalStateHelper: GlobalStateHelper,
    private routeMapHelper: RouteMapHelper
  ) {
    this.currentLang = ConfigService.getCurrentLang();
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if( this.globalStateHelper.unlockLogoutPopup ) {
      return true;
    } else {
      this.globalStateHelper.unlockLogoutPopup = false;

      this.router.navigate(
        [
          `${this.currentLang}/${this.routeMapHelper.getRoute('my-reservation', this.currentLang)}/${this.routeMapHelper.getRoute('my-reservation_authorization-group', this.currentLang)}`
        ])
      return false;
    }
  }

}
